import api from './api';

export async function fetchAllProducts() {
  const res = await api.get('/products');
  return res.data;
}

// Fetch products directly from database (bypasses cache) for admin trade
// Returns ALL products regardless of status
export async function fetchProductsForAdminTrade() {
  const res = await api.get('/products/for-admin-trade');
  return res.data;
}

export async function updateProduct(productId, data) {
  const res = await api.put(`/products/${productId}`, data);
  return res.data;
}

export async function toggleProductActive(productId, isActive) {
  const res = await api.put(`/products/${productId}`, { isActive });
  return res.data;
}

export async function reorderProducts(orders) {
  const res = await api.post('/products/reorder', { orders });
  return res.data;
}

/**
 * Fetch trader product list with prices
 * Display quotes in online transactions
 * @returns {Promise<Array>} Array of trader products with buyPrice and sellPrice
 */
export async function fetchTraderProductList() {
  const { data } = await api.get('/trading/product/traderproductlist', {
    // Some environments aggressively cache GET responses for this endpoint.
    headers: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    },
  });

  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "دریافت لیست قیمت‌ها ناموفق بود";
    throw new Error(errorMessage);
  }

  return data.data || [];
}

/**
 * Update product quotes in online transactions (Admin)
 * Edit quotes in online transactions
 * @param {Object} productData - Product data to update
 * @returns {Promise<Object>} Updated product data
 */
export async function updateAdminProduct(productData) {
  const { data } = await api.post('/trading/product/adminproductupdate', productData);

  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "ویرایش مظنه ناموفق بود";
    throw new Error(errorMessage);
  }

  return data.data;
}

/**
 * Fetch admin product list
 * List quotes in online transactions
 * @returns {Promise<Array>} Array of admin products
 */
export async function fetchAdminProductList() {
  const { data } = await api.get('/trading/product/adminproductlist');

  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "دریافت لیست مظنه‌ها ناموفق بود";
    throw new Error(errorMessage);
  }

  return data.data || [];
}

/**
 * Create product for coin
 * @param {Object} productData - Product data to create
 * @returns {Promise<Object>} Created product data
 */
export async function createProductForCoin(productData) {
  const { data } = await api.post('/trading/product/createforcoin', productData);

  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "ایجاد مظنه ناموفق بود";
    throw new Error(errorMessage);
  }

  return data.data;
}
